import LinkRow from './linkRow.view';

export default LinkRow;
